<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs row">
                        <div class="col-xs-12 col-sm-fill hidden-xs">
                            <h3>
                                <i class="las" :class="$router.currentRoute.meta.icon"></i>
                                {{$router.currentRoute.meta.title}}
                            </h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xl-12">
                            <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">

                                <div class="row">
                                    <div class="col-xs-12 col-md-6 col-lg-4">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>
                                                Cliente:
                                            </h5>
                                            <autocomplete ref="clienteNome" :search="searchAutocompleteCliente" placeholder="Pesquise o cliente aqui..." aria-label="Pesquise o cliente aqui (nome, CNPJ..)" :get-result-value="getResultAutocompleteCliente" @submit="submitAutocompleteCliente"></autocomplete>               
                                        </div>
                                    </div>
                                    <div class="col-xs-6 col-md-6 col-lg-4 col-xl-3">
                                        <div class="submit-field">
                                            <h5>
                                                Valor mensal (R$):
                                            </h5>
                                            <money v-model="form.valor" @keydown="$event.key === '-' ? $event.preventDefault() : null" v-bind="$root.config.money" class="with-border"></money>            
                                        </div>
                                    </div>
                                    <div class="col-xs-6 col-md-6 col-lg-4 col-xl-3">
                                        <div class="submit-field">
                                            <h5>
                                                Dia de pagamento:
                                            </h5>
                                            <input type="number" min="1" max="31" class="with-border" placeholder="" required=""  v-model="form.diaPagamento">
                                        </div>
                                    </div>    
                                    <div class="col-xl-12"></div>
                                    <div class="col-xs-6 col-md-6 col-lg-4 col-xl-3">
                                        <div class="submit-field">
                                            <h5>
                                                Data de início:
                                            </h5>
                                            <input type="date" class="with-border" placeholder="" required=""  v-model="form.dataInicio">
                                        </div>
                                    </div>
                                    <div class="col-xs-6 col-md-6 col-lg-4 col-xl-3">
                                        <div class="submit-field">
                                            <h5>
                                                Data final:
                                            </h5>
                                            <input type="date" class="with-border" placeholder="" required=""  v-model="form.dataFinal">
                                        </div>
                                    </div>    

                                    <div class="col-xs-6 col-md-6 col-lg-4 col-xl-3">
                                        <div class="submit-field">
                                            <h5 style="opacity: 0">
                                                a
                                            </h5>                                        
                                            <button v-on:click="replaceContrato" type="button" class="button color-gray">
                                                <i class="las la-sync-alt"></i> Atualizar texto
                                            </button>
                                        </div>    
                                    </div>    


                                    <div class="col-xl-12"></div>

                                    <div class="col-xs-12 margin-top-20" v-bind:class="{'disabled': !form.conteudo}">
                                        <div class="submit-field">
                                            <h5>
                                                <i class="las la-file-contract"></i>
                                                Texto do contrato
                                            </h5>
                                            <trumbowyg v-model="form.conteudo" :config="config" class="" name="conteudo"></trumbowyg>
                                        </div>
                                    </div>

                                    <div class="col-xl-12 margin-top-50 margin-bottom-30">
                                        <button type="submit" v-if="form.ativo == 1 || !form.cod" class="button color-green block-mobile" v-bind:class="{'disabled': loading.submit }">
                                            <i class="las la-save"></i>
                                            Salvar contrato
                                        </button>
                                        <button v-if="form.cod && form.ativo == 1" type="button" v-on:click="del(form.cod)" class="button outline-gray block-mobile">
                                            <i class="las la-ban"></i>
                                            Excluir contrato
                                        </button>                                          
                                    </div>
                                </div>
                            </form>
                        </div> 
                    </div>                

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'
import AvatarCropper from "vue-avatar-cropper"

export default {
    name: 'GerenciarContratos',
    components: {
        'Trumbowyg':        VueTrumbowyg.default,
        'AvatarCropper':    AvatarCropper,
        'Top':              Top,
        'Sidebar':          Sidebar,
        'Toolbar':          Toolbar
    },          
    data () {
        var self                    = this;
        return {
            "salvo":        false,
            "config": {
                svgPath:    "https://cdnjs.cloudflare.com/ajax/libs/Trumbowyg/2.20.0/ui/icons.svg",
                btns: [
                    ['undo', 'redo'],
                    ['formatting'],
                    ['fontsize'],
                    ['strong', 'em', 'del'],
                    ['link'],
                    // ['insertImage'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                    ['unorderedList', 'orderedList'],
                    ['horizontalRule'],
                    ['removeformat'],
                    // ['fullscreen']
                ]
            },         
            "loading": {
                "submit":           false
            },
            "clientes": {
                "itens":            []
            },            
            "form": {
                "_cod":             "",
                "_token":           "",
                "nome":             "",
                "clienteCod":       "",
                "conteudo":         ""
            }            
        }
    },

    watch: {
        "form.clienteCod": function(val) {
            var self = this;
            console.log("watch > form.clienteCod", val);

            self.form.cliente   = self.clientes.itens.filter(function(item) {
                if (item.cod == self.form.clienteCod) return item;
            })[0];

            console.log("Setou cliente", self.form.cliente)

            self.$forceUpdate();

        }
    },
    methods: {
        submitAutocompleteCliente: function(obj) {
            console.log("submitAutocompleteCliente", obj)
            var self = this;
            self.form.clienteCod    = obj.cod;
            // self.form.cliente       = obj;
            self.$forceUpdate();
            console.log("Setou form", self.form)
        },        
        getResultAutocompleteCliente: function(result) {
          return (result.empresa ? result.empresa : result.nome);
        },            
        searchAutocompleteCliente: function(val, all) {
            var self = this;
            return new Promise(function(resolve, reject) {
                if (!val) {
                    resolve([]);
                    return false;
                }

                if (self.requestAutocomplete) {
                    self.requestAutocomplete.cancel(); 
                }

                self.requestAutocomplete = axios.CancelToken.source();  
                
                var form = {
                    "db":               "clientes",
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "page":         1,
                        "autocomplete": true,
                        "all":          (all || false),
                        "pesquisa":     val
                    },
                    "cancelToken":      self.requestAutocomplete.token  
                };

                axios.get("api/clientes.php", form)
                .then(response => {
                    
                    resolve(response.data.result.itens);
  
                })
                .catch(error => {
                    loading.hide();
                    reject(error);
                }); 

            });
        },           
        replaceContrato: function() {
            var self        = this;
            console.log("replaceContrato()");

            if (!self.form.clienteCod) return false;
            if (!self.form.dataInicio) return false;
            if (!self.form.dataFinal) return false;
            if (!self.form.valor) return false;

            self.form.conteudo      = self.$root.config.configuracoes.contratoPadrao;                

            // faz replace das variaveis

            var meses = [
              "Janeiro",
              "Fevereiro",
              "Março",
              "Abril",
              "Maio",
              "Junho",
              "Julho",
              "Agosto",
              "Setembro",
              "Outubro",
              "Novembro",
              "Dezembro"
            ];

            var listaEquipamentos   = "";
            self.form.cliente.equipamentos.forEach(function(item) {
                listaEquipamentos   = listaEquipamentos + item.quantidade + " " + item.nome + "<div style='display: block; width: 100%; margin-top: 10px;'></div>";
            });

            var variaveis           = {
                "clienteNome":      self.form.cliente.nome,
                "clienteEmpresa":   self.form.cliente.empresa,
                "endereco":         self.form.cliente.endereco,
                "enderecoNumero":   self.form.cliente.numero,
                "enderecoBairro":   self.form.cliente.bairro,
                "enderecoCep":      self.form.cliente.cep,
                "enderecoCidade":   self.form.cliente.cidade,
                "enderecoEstado":   self.form.cliente.estado,
                "clienteCnpj":      self.form.cliente.cnpj,
                "clienteCpf":       self.form.cliente.doc,
                "listaEquipamentos":listaEquipamentos,
                "valorMensal":      self.form.valor.toLocaleString('pt-br', {minimumFractionDigits: 2}),
                "valorMensalExtenso": extenso((self.form.valor.toString()).replace(".", ","), { mode: 'currency'}),
                "dataInicio":       formatDate(self.form.dataInicio),
                "dataFinal":        formatDate(self.form.dataFinal),
                "diaPagamento":     self.form.diaPagamento,
                "dia":              self.form.dataInicio.split("-")[2],
                "mes":              meses[new Date(self.form.dataInicio).getMonth()],
                "ano":              new Date(self.form.dataInicio).getFullYear(),
            };

            console.log("Variáveis:", variaveis);

            Object.keys(variaveis).forEach(function(item) {

                console.log(">", item)

                self.form.conteudo = self.form.conteudo.replaceAll("{{" + item + "}}", variaveis[item]);

            });

        },
        getClientes: function() {
            var self        = this;
            console.log("getClientes()");
            // loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "all":          true,
                        "page":         1
                    }
                };

                axios.get("api/clientes.php", form)
                .then(response => {
                    
                    console.log("getClientes() response", response);
                    self.clientes       = response.data.result;
                    // loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getClientes() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },
        submit: function(e) {
            
            var self            = this;
            // if (self.form.tipo != "admin" && self.form.tipo != "prestador") return false;
            self.form._cod      = self.$root.user.cod;
            self.form._token    = self.$root.user.token;
            console.log("submit()", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
                
            var a = "post";
            if (self.form.cod) {
                a = "put";
            }

            console.log("acao", a);

            axios[a]("api/contratos.php", self.form)
            .then(response => {
                
                self.salvo          = true;
                self.loading.submit = false;
                console.log("submit() response", response)
                loading.hide();
                alert(response.data.message);
                self.$root.back();
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            // loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          self.form.cod
                    }
                };

                axios.get("api/contratos.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.form           = response.data.result;
                    self.loaded         = true;
                    // loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    // loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },
        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar?", function() {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          cod
                    }
                };
                loading.show();
                
                axios.delete("api/contratos.php", form)
                .then(response => {
                    console.log("del() response", response)
                    self.salvo          = true;
                    self.$root.back();
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        }               
    },    
    created: function() {
        var self = this;
        console.log("created", self);

        if (self.$route.name == "EditarContratos") {
            if (!self.$route.query.c) {
                self.$root.back();
                return false;
            }
            loading.show();
            self.form.cod = self.$route.query.c;
            Promise.resolve()
            .then(self.getClientes)         
            .then(self.$root.getConfig)             
            .then(self.get)             
            .finally(function() {

                setTimeout(function() {
                    loading.hide();
                }, 500);

            });      
        } else {
           

            var dateAdd = function(date, interval, units) {
                var ret = new Date(date);
                switch(interval.toLowerCase()) {
                    case 'years'   :  ret.setFullYear(ret.getFullYear() + parseFloat(units));  break;
                    case 'quarters':  ret.setMonth(ret.getMonth() + 3*parseFloat(units));  break;
                    case 'months'  :  ret.setMonth(ret.getMonth() + parseFloat(units));  break;
                    case 'weeks'   :  ret.setDate(ret.getDate() + 7*parseFloat(units));  break;
                    case 'days'    :  ret.setDate(ret.getDate() + parseFloat(units));  break;
                    case 'hours'   :  ret.setTime(ret.getTime() + parseFloat(units)*3600000);  break;
                    case 'minutes' :  ret.setTime(ret.getTime() + parseFloat(units)*60000);  break;
                    case 'seconds' :  ret.setTime(ret.getTime() + parseFloat(units)*1000);  break;
                    default       :  ret = undefined;  break;
                }
                return ret;
            }

            self.form.dataInicio    = getNow(true);
            self.form.dataFinal     = getNow(true, false, dateAdd(self.form.dataInicio, "years", 1));

            // console.log("setou", self.form.dataFinal)

            Promise.resolve()
            .then(self.getClientes)         
            .then(self.$root.getConfig)             
            .finally(function() {

                setTimeout(function() {
                    loading.hide();
                }, 500);

            });            
        }
    },
    activated: function() {
        var self = this;

    },
    beforeRouteLeave (to, from, next) {
        var self = this;
        if (!self.salvo) {
            const answer = window.confirmWeb('Você tem certeza que deseja sair da página atual? Modificações não salvas podem ser perdidas.')
            if (!answer) return false;
        }
        next();
    }    
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .card .dashboard-status-button {
        margin-top: 8px;
    }

    .uploadButton-button {
        display: none !important;
    }        
    .button.gray.block-mobile {
        font-weight: 400;
        border: 1px solid #ddd !important;
    }

    .imagem-preview {
        width: 100%;
        height: 35vh;
        border-radius: 10px;
        margin-bottom: 25px !important;
        background-size: contain;
        background-color: #ddd;
        background-position: center;
        background-repeat: no-repeat;
    }    

    .uploadButton .uploadButton-input {
        opacity: 0 !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/GerenciarContratos.vue